import { GET, POST, POSTFORMDATA, POSTFORMDATA2 } from "../index";
import { BASE, LocalBase } from "@/config/index";

// 素材列表获取
export const listMaterial = POST(
  `${BASE}/content/materialManager/listMaterial`
);

// 素材列表获取按照工作组获取
export const listMaterialForProgram = POST(
  `${BASE}/content/materialManager/listMaterialForProgram`
);

// 素材缩略图下载链接获取
export const getMaterialDownloadUrl = GET(
  `${BASE}/content/materialManager/getMaterialDownloadUrl`
);

// 素材详情接口
export const getMaterialDetail = GET(
  `${BASE}/content/materialManager/getMaterialDetail`
);

// 视频预览缩略图
export const getVideoPreview = GET(
  `${BASE}/content/materialManager/getVideoPreview`
);

// 获取节目模板
export const listProgramTemplate = GET(
  `${BASE}/content/programManager/listProgramTemplate`
);

// 节目列表获取
export const listProgram = POST(`${BASE}/content/programManager/listProgram`);


// 节目列表获取-首页
export const listIndexProgram = (params) => GET(`${BASE}/content/programManager/listIndexProgram?number=${params.number}`)();

// 保存节目
export const saveProgram = POSTFORMDATA2(
  `${BASE}/content/programManager/saveProgram`
);

// 更新节目
export const updateProgram = POSTFORMDATA2(
  `${BASE}/content/programManager/updateProgram`
);

// 删除节目
export const deleteProgram = POST(
  `${BASE}/content/programManager/batchDeleteProgram`
);

// 查询节目
export const getProgram = GET(`${BASE}/content/programManager/getProgram`);

// 查询节目
export const getScheduleName = POST(
  `${BASE}/content/scheduleManager/getScheduleNameByProgramIds`
);

// 基于工作组获取节目数据
export const getProgramInfoByWorkGroupId = POST(
  `${BASE}/content/programManager/getProgramInfoByWorkGroupIdAndProgramType`
);

// 节目文本校验
export const verifyContent = POST(
  `${BASE}/content/programManager/verifyContent`
);

// // 城市id获取
// export const getCityInfo = GET(
//   `${BASE}/content/programManager/getCityInfo`
// );

// 城市信息获取(列表)
export const listCityInfo = POST(
  `${BASE}/content/programManager/listCityInfo`
);

// 城市信息获取（树型分级）
export const getCityInfo = GET(
  `${BASE}/content/programManager/getCityInfo`
);

// 根据城市id获取城市天气
export const getWeatherInfo = GET(
  `${BASE}/content/programManager/getWeatherInfo`
);
